import { ClassCategoryEnum } from './enums/ClassCategoryEnum';

export class ClassAndEndpoint{
    class:ClassCategoryEnum;
    endpoint:number;
}